import './lle_land_details.css';
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { FILE_NAME_VALIDATION_ERROR, LAND_DOCUMENT } from '../../../../common/constants';
import { APPLICATION_ADDRESS_EVIDENCE, EXISTING_OCC, GENDER, HIGHEST_QUALIFICATION, LLE_TRADE_LICENSE, MOA_REGISTRATION_CERTIFICATE } from '../../../../common/constants';
import { ADJACENT_DISTRICT, BEYOND_25_KM, OTHER_DISTRICT, WITHIN_25_KM, MORE_THAN_4_BIGAH, BTWN_3_4_BIGAH } from '../../../../common/constants';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { Container, Card, CardContent, Button, RadioGroup, Radio, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { PROD } from '../../../../common/constants';
import { downloadDocument, uploadDocument } from '../../../../common/Utils';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { fileNameValidation } from '../../../../common/commonValidations';
import { t } from 'i18next';
import { ArrowBackIosNewIcon, ArrowForwardIosIcon } from '../../../../common/icons';

const LLELandDetails = () => {

    const [prevScreenData, setPrevScreenData] = useState();
    const [backButtonData, setBackButtonData] = useState();
    const [isRoadConnectivityValid, setIsRoadConnectivityValid] = useState(true);
    const [isOptedLandValid, setIsOptedLandValid] = useState(true);
    const [applicantAddressRangeFromOperationArea, setApplicantAddressRangeFromOperationArea] = useState(WITHIN_25_KM);
    const [landAvailability, setLandAvailability] = useState(MORE_THAN_4_BIGAH);
    const [registrationFileName, setRegistrationFileName] = useState();
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [errorMessage, setErrorMessage] = useState({
        residenceDocError: '',
        taxDocError: ''
    });
    const [documentDetailsArr, setDocumentDetailsArr] = useState([]);
    const [landType, setLandType] = useState("Owned");
    const [documentDetailsObj, setDocumentDetailsObj] = useState({
        // id: null,
        documentType: null,
        documentName: null,
        documentBlobName: null,
        documentPath: null,
        documentContainerName: "stakeholder",
        stakeholderType: "lle",
        stakeholderDetailId: null,
        isActive: 1,
        createdOn: null,
        createdBy: null,
        updatedOn: null,
        updatedBy: null,
    });

    const [addressCertiFileName, setAddressCertiFileName] = useState();
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const [showOwnedLabel, setOwnedLabel] = useState(true);
    const [showLeasedLabel, setLeasedLabel] = useState(false);
    const [landTypeFileName, setLandTypeFileName] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const allowedTypes = ["image/png", "image/jpg", "image/jpeg", "application/pdf"];

    const onRadioButtonClick = (e) => {
        // setDetails({ ...details, [e.target.name]: e.target.value })
        setLandType(e.target.value)
        if (e.target.name === "Owned_type") {
            if (e.target.value === "Owned") {
                setOwnedLabel(true);
                setLeasedLabel(false);
            }
            else if (e.target.value === "Leased") {
                setOwnedLabel(false);
                setLeasedLabel(true);
            }

        }

    }

    useEffect(() => {
        setBackButtonData(location.state.data);
        if (backButtonData) {
            setApplicantAddressRangeFromOperationArea(backButtonData.applicantAddressRangeFromOperationArea ? backButtonData.applicantAddressRangeFromOperationArea : WITHIN_25_KM);
            setIsOptedLandValid(backButtonData.isOptedLandValid ? backButtonData.isOptedLandValid : true);
            setIsRoadConnectivityValid(backButtonData.isRoadConnectivityValid ? backButtonData.isRoadConnectivityValid : true);
            setLandAvailability(backButtonData.landAvailability ? backButtonData.landAvailability : MORE_THAN_4_BIGAH)
            setLandType(backButtonData.landType ? backButtonData.landType : "Owned")
            setAddressCertiFileName(backButtonData?.documents?.[0]?.documentType === "ApplicantAddressEvidence" ? backButtonData?.documents?.[0]?.documentName : backButtonData?.documents?.[1]?.documentType === "ApplicantAddressEvidence" ? backButtonData?.documents?.[1]?.documentName : backButtonData?.documents?.[2]?.documentType === "ApplicantAddressEvidence" ? backButtonData?.documents?.[2]?.documentName : backButtonData?.documents?.[3]?.documentType === "ApplicantAddressEvidence" ? backButtonData?.documents?.[3]?.documentName : backButtonData?.documents?.[4]?.documentType === "ApplicantAddressEvidence" ? backButtonData?.documents?.[4]?.documentName : backButtonData?.documents?.[5]?.documentType === "ApplicantAddressEvidence" ? backButtonData?.documents?.[5]?.documentName : "")
            setLandTypeFileName(backButtonData?.documents?.[0]?.documentType === "LandDocument" ? backButtonData?.documents?.[0]?.documentName : backButtonData?.documents?.[1]?.documentType === "LandDocument" ? backButtonData?.documents?.[1]?.documentName : backButtonData?.documents?.[2]?.documentType === "LandDocument" ? backButtonData?.documents?.[2]?.documentName : backButtonData?.documents?.[3]?.documentType === "LandDocument" ? backButtonData?.documents?.[3]?.documentName : backButtonData?.documents?.[4]?.documentType === "LandDocument" ? backButtonData?.documents?.[4]?.documentName : backButtonData?.documents?.[5]?.documentType === "LandDocument" ? backButtonData?.documents?.[5]?.documentName : "")

        }

    }, [backButtonData]);
    const deleteDocument = (blobFileName, documentType) => {
        let existingData = documentDetailsArr.filter((item) => item.documentType === documentType && item.documentBlobName === blobFileName);
        let tempArr = documentDetailsArr.filter((item) => item.documentBlobName !== blobFileName);
        if (existingData && existingData[0]) {
            if (existingData[0].id) {
                existingData[0].isActive = 0;
                tempArr?.push(existingData[0]);
            }
        }
        setDocumentDetailsArr(tempArr);
    };
    const onClickDocument = (e, blobFileName, documentName) => {
        e.preventDefault();
        downloadDocument(blobFileName, documentName, null);
    };
    const onSubmit = (e) => {
        const dataForApi = {
            ...prevScreenData,
            "landAvailability": landAvailability,
            "landType": landType,
            "applicantAddressRangeFromOperationArea": applicantAddressRangeFromOperationArea,
            "documents": documentDetailsArr

        }
        let residenceDoc = documentDetailsArr && documentDetailsArr.filter((item) => item.documentType === APPLICATION_ADDRESS_EVIDENCE && item.isActive == 1);
        let taxDoc = documentDetailsArr && documentDetailsArr.filter((item) => item.documentType === LAND_DOCUMENT && item.isActive == 1);

        // if (residenceDoc.length == 0) {
        //     setErrorMessage({ residenceDocError: "Please upload residence proof document" });
        // }
        // else if (taxDoc.length == 0) {
        //     setErrorMessage({ taxDocError: "Please upload Jamabandi /Khajana or Tax paid receipt" });
        // }
        // else {
            navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/llepowerDetails' : '/preregistration/llepowerDetails', { state: { data: dataForApi } });
        // }
    }
    const onUploadDocument = (e, type) => {
        if (allowedTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].name.split('.').length > 2) {
            if (type === APPLICATION_ADDRESS_EVIDENCE) {
                setErrorMessage({
                    ...errorMessage,
                    residenceDocError: "Double extension file detected",
                });
            }
            else {
                setErrorMessage({
                    ...errorMessage,
                    taxDocError: "Double extension file detected",
                });
            }
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            if (type === APPLICATION_ADDRESS_EVIDENCE) {
                setErrorMessage({
                    ...errorMessage,
                    residenceDocError: "The file should be less than 5MB",
                });
            }
            else {
                setErrorMessage({
                    ...errorMessage,
                    taxDocError: "The file should be less than 5MB",
                });
            }
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            if (type === APPLICATION_ADDRESS_EVIDENCE) {
                setErrorMessage({
                    ...errorMessage,
                    residenceDocError: FILE_NAME_VALIDATION_ERROR,
                });
            }
            else {
                setErrorMessage({
                    ...errorMessage,
                    taxDocError: FILE_NAME_VALIDATION_ERROR,
                });
            }


        }
        else {
            if (type === APPLICATION_ADDRESS_EVIDENCE) {
                setErrorMessage({ ...errorMessage, residenceDocError: "" });
            }
            else {
                setErrorMessage({ ...errorMessage, taxDocError: "" });
            }

            setSelectedFile(e.target.files[0]);
            setDocumentDetailsObj({
                ...documentDetailsObj,
                documentType: type,
                stakeholderDetailId: null,
            })
        }


        if (type === APPLICATION_ADDRESS_EVIDENCE) {
            setAddressCertiFileName(e.target.files[0].name)
        }

        else
            if (type === LAND_DOCUMENT) {
                setLandTypeFileName(e.target.files[0].name)
            }
        uploadDocument(e.target.files[0], type, callbackUpload);

    };
    const callbackUpload = (response, type) => {
        setDocumentUploadDetails(response);
        var document = {
            id: null,
            documentType: type,
            documentName: response?.blobResponse?.fileName,
            documentBlobName: response?.blobResponse?.blobFileName,
            documentPath: null,
            documentContainerName: "stakeholder",
            stakeholderType: "LLE",
            //stakeholderDetailId: props.stakeholderDetailId,
            isActive: 1
        }
        var tempArr = documentDetailsArr;
        tempArr.push(document);
        setDocumentDetailsArr(tempArr);
    }
    const onApplicantClick = (e) => {
        e.preventDefault()
        setSelectedApplicant(e.target.value)
    }
    useEffect(() => {
        setPrevScreenData(location.state.data)
        setSelectedApplicant(location.state.data.applicantType);
        setDocumentDetailsArr(location.state.data?.documents)

    }, [prevScreenData]);

    const landAvailabilityOnChange = (e) => {
        setLandAvailability(e.target.value)
    }
    const isRoadConnectivityValidOnchange = (e) => {
        if (e.target.value === "true") {
            setIsRoadConnectivityValid(true)

        } else {
            setIsRoadConnectivityValid(false)

        }

    }

    const isOptedLandValidOnChange = (e) => {
        if (e.target.value === "true") {
            setIsOptedLandValid(true);
        } else {
            setIsOptedLandValid(false)
        }
    }

    const onApplicantAddressRangeChange = (e) => {
        setApplicantAddressRangeFromOperationArea(e.target.value)
    }




    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG07</p>}
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            {t('preReg.informationAboutOptedLocation')}
                        </Typography>
                        <Typography variant="subtitle2" gutterBottom>
                            {t('preReg.applicantType')}
                        </Typography>
                        <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                            color="primary"
                            value={selectedApplicant}
                            exclusive
                            onChange={(e) => onApplicantClick(e)}
                            aria-label="Platform"
                        >
                            <ToggleButton disabled value="Individual">{t('preReg.individual')}</ToggleButton>
                            <ToggleButton disabled value="SHG/Co-opetative">{t('preReg.shg')}/{t('preReg.cooperative')}</ToggleButton>
                            <ToggleButton disabled value="Firm/Enterprise">{t('preReg.firm')}/{t('preReg.enterprise')}</ToggleButton>
                        </ToggleButtonGroup>
                        <Grid container spacing={2} direction="row" mt={1}>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                                    {t('preReg.applicantPermanentResidence')}
                                </Typography>
                                <RadioGroup
                                    defaultValue={WITHIN_25_KM}
                                    name="lle_applicant_address"
                                >
                                    <FormControlLabel value={WITHIN_25_KM} control={<Radio checked={applicantAddressRangeFromOperationArea === WITHIN_25_KM} onChange={(e) => onApplicantAddressRangeChange(e)} />} label={t('preReg.within25km')} />
                                    <FormControlLabel value={BEYOND_25_KM} control={<Radio checked={applicantAddressRangeFromOperationArea === BEYOND_25_KM} onChange={(e) => onApplicantAddressRangeChange(e)} />} label={t('preReg.beyond25km')} />
                                    <FormControlLabel value={ADJACENT_DISTRICT} control={<Radio checked={applicantAddressRangeFromOperationArea === ADJACENT_DISTRICT} onChange={(e) => onApplicantAddressRangeChange(e)} />} label={t('preReg.adjacentDistrict')} />
                                    <FormControlLabel value={OTHER_DISTRICT} control={<Radio checked={applicantAddressRangeFromOperationArea === OTHER_DISTRICT} onChange={(e) => onApplicantAddressRangeChange(e)} />} label={t('preReg.otherDistrict')} />
                                </RadioGroup>
                                <Typography variant="caption" style={{ fontStyle: "italic" }}>{t('preReg.uploadProofOfResidence')}(Aadhaar/ Voter ID/ Ration card/ Passport/ MOA or Registration of Society/ SHG/ Firm/ Company)</Typography>
                                {documentDetailsArr?.filter(item => item.documentType === APPLICATION_ADDRESS_EVIDENCE && item.isActive === 1).map(item => (
                                    <div className="chooseFile_storage">
                                        <a onClick={(e) => onClickDocument(e, item.documentBlobName, item.documentName)}>{item.documentName}</a>
                                        <IconButton size='small' className='icon_button_grower_pre_reg' color="primary" aria-label="search"
                                            onClick={() => deleteDocument(item.documentBlobName, item.documentType)}>
                                            <DeleteIcon color='error' fontSize='inherit' />
                                        </IconButton>
                                    </div>
                                ))
                                }
                                {(documentDetailsArr)?.filter(item => item.documentType === APPLICATION_ADDRESS_EVIDENCE && item.isActive === 1).length == 0 ?
                                    <label className="chooseFile_storage">
                                        <input type="file" accept="image/png, image/jpg, image/jpeg ,.doc, .pdf" name="uploadedfile2"
                                            style={{ display: "none" }}
                                            onChange={(e) => onUploadDocument(e, APPLICATION_ADDRESS_EVIDENCE)} />
                                        {t('preReg.uploadFile')}
                                    </label> : null}
                                <div className='mandatory_field'>{errorMessage.residenceDocError}</div>
                                <Typography variant="subtitle2" fontSize="1.8vh" align="right" color="green">{t('preReg.uploadFileTypeNote')}</Typography>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                                    {t('preReg.availabilitOfLandForChippingUnit')} <Typography style={{ marginTop: 4 }} variant="subtitle2" gutterBottom>{t('preReg.ownOrlease')}</Typography>
                                </Typography>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue={MORE_THAN_4_BIGAH}
                                    name="land_availability"
                                >
                                    <FormControlLabel value={MORE_THAN_4_BIGAH} control={<Radio checked={landAvailability === MORE_THAN_4_BIGAH} onChange={(e) => landAvailabilityOnChange(e)} />} label={t('preReg.morethan4bighas')} />
                                    <FormControlLabel value={BTWN_3_4_BIGAH} control={<Radio checked={landAvailability === BTWN_3_4_BIGAH} onChange={(e) => landAvailabilityOnChange(e)} />} label={t('preReg.between3to4bighas')} />
                                </RadioGroup>
                                <Typography variant="body2" gutterBottom>
                                    {t('preReg.optedLandDescript')}
                                </Typography>
                                <Typography variant="subtitle2" mt={2} gutterBottom>
                                    {t('preReg.ownnershipType')}
                                </Typography>
                                <RadioGroup row
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="Owned"
                                    name="Owned_type"
                                >
                                    <FormControlLabel value="Owned" control={<Radio checked={landType === "Owned"} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.owned')} />
                                    <FormControlLabel value="Leased" control={<Radio checked={landType === "Leased"} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.lease')} />
                                </RadioGroup>
                                {showOwnedLabel && <Typography variant="caption" style={{ fontStyle: "italic" }}>{t('preReg.uploadJamabandiKhajnaTax')}</Typography>}
                                {showLeasedLabel && <Typography variant="caption" style={{ fontStyle: "italic" }}>{t('preReg.uploadJamabandiReceiptLandOwnerTax')}</Typography>}
                                {documentDetailsArr?.filter(item => item.documentType === LAND_DOCUMENT && item.isActive === 1).map(item => (
                                    <div className="chooseFile_storage">
                                        <a onClick={(e) => onClickDocument(e, item.documentBlobName, item.documentName)}>{item.documentName}</a>
                                        <IconButton size='small' className='icon_button_grower_pre_reg' color="primary" aria-label="search"
                                            onClick={() => deleteDocument(item.documentBlobName, item.documentType)}>
                                            <DeleteIcon color='error' fontSize='inherit' />
                                        </IconButton>
                                    </div>
                                ))
                                }
                                {(documentDetailsArr)?.filter(item => item.documentType === LAND_DOCUMENT && item.isActive === 1).length == 0 ?
                                    <label className="chooseFile_storage">
                                        <input type="file" accept="image/png, image/jpg, image/jpeg ,.doc, .pdf" name="uploadedfile2"
                                            style={{ display: "none" }}
                                            onChange={(e) => onUploadDocument(e, LAND_DOCUMENT)} />
                                        {t('preReg.uploadFile')}
                                    </label> : null}
                                <div className='mandatory_field'>{errorMessage.taxDocError}</div>
                                <Typography variant="subtitle2" fontSize="1.8vh" align="right" color="green">{t('preReg.uploadFileTypeNote')}</Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" startIcon={<ArrowBackIosNewIcon />} onClick={() => (navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/lleoptedLocation' : '/preregistration/lleoptedLocation', { state: { data: prevScreenData } }))}>{t('preReg.previous')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" endIcon={<ArrowForwardIosIcon />} onClick={(e) => onSubmit(e)}>{t('preReg.next')}</Button>
                </Box>
            </Container>
        </>
    );
}

export default LLELandDetails;
